// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import renderHTML from "react-render-html";
import { EDITOR_HTML_TAGS } from "../variables/Constants";

export function sanitizeAndRenderHTML(html) {
  return renderHTML(sanitizeHTMLString(html));
}

export function revertHTMLWithTags(html) {
  if (!html) return html;
  let replace = html && html.replaceAll(/&lt;/g, '<').replace(/&gt;/g, '>');
  return replace;
}

export function escapeHTMLSpecialChars(html) {
  return html.replaceAll(/</g, '&lt;').replaceAll(/>/g, '&gt;');
}

export function sanitizeHTMLString(html) {
  if (html == null) return '';
  let htmlEscaped = escapeHTMLSpecialChars(html);
  EDITOR_HTML_TAGS.forEach(tag => {
    // Create RegExp to match escaped opening and closing tags
    const openTagRegex = new RegExp(`&lt;(${tag}(?:\\s+[^&>]*?)?)&gt;`, 'g');
    const closeTagRegex = new RegExp(`&lt;/(${tag})&gt;`, 'g');    
    htmlEscaped = htmlEscaped.replace(openTagRegex, '<$1>');    
    htmlEscaped = htmlEscaped.replace(closeTagRegex, '</$1>');
  });
  return htmlEscaped;
}

function wrapStringWithHTMLTag(html, tag) {
  return `<${tag}>${html}</${tag}>`;
}

export function wrapSubstringWithHTMLTag(keywordsObj, html, tag){
  let htmlString = html;
  for (let key of Object.values(keywordsObj)) {
    htmlString = htmlString.replaceAll(new RegExp(key, 'g'), wrapStringWithHTMLTag(key, tag));
  }
  return htmlString;
}

export default {
  sanitizeHTMLString,
  sanitizeAndRenderHTML,
  revertHTMLWithTags,
  wrapSubstringWithHTMLTag
};
